import { render, staticRenderFns } from "./FilterPackage.vue?vue&type=template&id=95bd993a&scoped=true&"
import script from "./FilterPackage.vue?vue&type=script&lang=js&"
export * from "./FilterPackage.vue?vue&type=script&lang=js&"
import style0 from "./FilterPackage.vue?vue&type=style&index=0&id=95bd993a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95bd993a",
  null
  
)

export default component.exports